import { Fragment as _Fragment, jsx as _jsx } from "react/jsx-runtime";
import { Pressable, StyleSheet, } from 'react-native';
import { theme } from '@xbto/design-system';
import { withShadowDOM } from '../../hoc';
import { useBreakpoints } from '../../hooks';
export function TableCell({ children, onPress, renderInShadowDOM, width, align, hidden = false, Wrapper, style, }) {
    const { breakpoints } = useBreakpoints();
    const computedStyles = StyleSheet.flatten([
        $.container,
        breakpoints.S && $.container_S,
        { width },
        {
            justifyContent: align === 'right' ? 'flex-end' : 'flex-start',
        },
        style,
    ]);
    const content = renderInShadowDOM
        ? withShadowDOM(() => _jsx(_Fragment, { children: children }))
        : children;
    if (hidden) {
        return null;
    }
    if (Wrapper !== undefined) {
        return _jsx(Wrapper, { style: computedStyles, children: content });
    }
    else {
        return (_jsx(Pressable, { onPress: onPress, disabled: !onPress, style: computedStyles, children: content }));
    }
}
const $ = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        borderBottomWidth: 1,
        borderColor: theme.color.border.primary,
        paddingHorizontal: theme.spacing['6'],
    },
    container_S: {
        paddingHorizontal: theme.spacing['4'],
    },
});
